module.exports = __webpack_public_path__ + "static/case8.png";